import React from "react";
import { useTranslation } from "react-i18next";
import { AdminPortalShieldIcon } from "@components/common/Icons/AdminPortalShieldIcon";

export const HeaderBranding: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="header-branding flex min-w-0 items-center">
			<AdminPortalShieldIcon className="header-branding__icon shrink-0" />
			<h1 id="project-title" className="header-branding__title truncate font-sans">
				{t("psdaCommon.auth.pageTitle.committeePortal", "Committee Portal")}
			</h1>
		</div>
	);
};
